import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import AdvForm from '../../../../CommonComponents/AdvForm';
import { isNumeric } from '../../../../../js/app/react/validators';
import InputDollar from '../../../InputDollar/InputDollarView';

export const withEmptyStringWhenNull = value => (value === null ? '' : value);

export const validator = amount => () => {
  if (!isNumeric(amount) || +amount < 0 || amount < 0) {
    return ['Please specify an estimated amount'];
  }
  return [];
};

const AnnualPropertyTax = ({
  workflowId,
  branch,
  nullableAnnualPropertyTax,
  onAnnualPropertyTaxChanged,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId}>
    <Validation
      workflowId={workflowId}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.PropertyTax`}
    />
    <h2>What is the expected annual property tax?</h2>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputDollar
            isUnder
            placeholder="Property Tax"
            placeholderClassName="adv-workflows-placeholder-large"
            className="md text-center"
            value={withEmptyStringWhenNull(nullableAnnualPropertyTax)}
            onChange={onAnnualPropertyTaxChanged(workflowId)}
            id="adv-property-tax"
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={validator(nullableAnnualPropertyTax)}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.PropertyTax`}
      workflowId={workflowId}
      backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
    />
  </AdvWorkflowStep>
);

AnnualPropertyTax.defaultProps = {
  nullableAnnualPropertyTax: null,
};

AnnualPropertyTax.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  onAnnualPropertyTaxChanged: PropTypes.func.isRequired,
  nullableAnnualPropertyTax: PropTypes.number,
};

export default AnnualPropertyTax;
